import { render, staticRenderFns } from "./procurementOverview.vue?vue&type=template&id=364b807f&scoped=true"
import script from "./procurementOverview.vue?vue&type=script&lang=js"
export * from "./procurementOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b807f",
  null
  
)

export default component.exports